export function isPasswordRecoveryUrl(): boolean {
  if (typeof window === "undefined") return false;

  const hash = new URLSearchParams(window.location.hash.slice(1));
  const query = new URLSearchParams(window.location.search);

  return (
    hash.get("type") === "recovery" ||
    query.get("type") === "recovery" ||
    (!!hash.get("access_token") && hash.get("type") === "recovery") ||
    !!query.get("code") ||
    (!!query.get("token_hash") && query.get("type") === "recovery")
  );
}

export function buildResetPasswordUrl(): string {
  return `/reset-password${window.location.search}${window.location.hash}`;
}
